// extracted by mini-css-extract-plugin
module.exports = {"pageLoader":"pageLoader___3vq0G","spinner":"spinner___GIIMy"};